import React from "react";

const SizeResult = ({ currentGuess, actualGuess }) => {
  let leadingValue = Math.max(currentGuess, actualGuess);
  let minorValue = Math.min(currentGuess, actualGuess);

  function calculateEarthSize() {
    // if (leadingValue < 12756) return;
    //convert km to px of the earth considering the ratio
    let newvalue = 6236 / leadingValue;
    const convertedValue = calculateLeadingSize() * newvalue;
    return Math.max(convertedValue, 0);
  }
  function calculateOtherPlanetSize() {
    //convert km to px of the other planet considering the ratio
    let newvalue = minorValue / leadingValue;
    const convertedValue = calculateLeadingSize() * newvalue;
    return Math.max(convertedValue, 0);
  }

  function calculateLeadingSize() {
    let convertedValue;
    if (leadingValue < 12756) {
      convertedValue = (leadingValue * 160) / 12756;
      //before maximum height of circle
    } else convertedValue = 160;
    //convert km to px of the circle
    return Math.max(convertedValue, 0);
  }

  const leadingSize = calculateLeadingSize();
  const earthSize = calculateEarthSize();
  const otherPlanetSize = calculateOtherPlanetSize();

  function calculateRatio(val) {
    //calculate the ratio of the circle and the earth
    const ratio = val / calculateEarthSize();
    const ratioString = ratio.toFixed(1);
    const [integerPart, decimalPart] = ratioString.split(".");
    return integerPart + "." + decimalPart;
  }

  return (
    <>
      <div className="flex flex-col font-orbitron">
        <div className="flex flex-row  max-w-md h-48 gap-6 w-full">
          <div className="w-full h-full bg-gray-dark flex py-4 px-8 justify-around items-end relative rounded-lg">
            <div className="absolute top-2 left-2 text-gray-light !text-xs">
              {currentGuess} /{" "}
              <span className="text-success-500">
                {actualGuess.toFixed(0) + " "}
              </span>
              km
            </div>
            <img
              src="/assets/images/earth.png"
              alt="Earth"
              style={{ width: `${earthSize}px`, height: `${earthSize}px` }}
            />
            <div
              className="relative"
              style={{
                width: `${leadingSize}px`,
                height: `${leadingSize}px`,
              }}
            >
              <div
                className="rounded-full border-dotted border-2 border-success-400 absolute bottom-0 left-1/2 transform -translate-x-1/2"
                style={{
                  width: `${leadingSize}px`,
                  height: `${leadingSize}px`,
                  color:
                    leadingValue === actualGuess
                      ? "rgb(94, 197, 111)"
                      : "white",
                  borderColor:
                    leadingValue === actualGuess
                      ? "rgb(94, 197, 111)"
                      : "white",
                }}
              >
                <span className="text-xs absolute -right-2">
                  {calculateRatio(leadingSize)}
                </span>
              </div>
              <div
                className="rounded-full border-dotted border-2 border-white absolute bottom-0 left-1/2 transform -translate-x-1/2"
                style={{
                  width: `${otherPlanetSize}px`,
                  height: `${otherPlanetSize}px`,
                  color:
                    minorValue === actualGuess ? "rgb(94, 197, 111)" : "white",
                  borderColor:
                    minorValue === actualGuess ? "rgb(94, 197, 111)" : "white",
                }}
              >
                <span className="text-xs">
                  {calculateRatio(otherPlanetSize)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SizeResult;
